import { put } from 'redux-saga/effects'
import { IPcr } from '../../../pcr/store/pcr.types'
import { initialAirwayNabc } from '../store/airway.reducers'
import { getSelectedDataFromObject } from '../../../../utilities/data.util'
import { saveInitialAssessmentAirwayNabc, setExam, setVerificationMethod } from '../store/airway.actions'

export function* getInitialAssessmentAirway(pcrDoc: IPcr) {
  if (pcrDoc && pcrDoc.prNabc) {
    const initialAssessmentAirwyaNabc = pcrDoc.prNabc

    const prNabcKeys: any = Object.keys(initialAirwayNabc)
    const prNabcData = getSelectedDataFromObject(initialAssessmentAirwyaNabc, prNabcKeys)
    if (Object.keys(prNabcData)?.length > 0) yield put(saveInitialAssessmentAirwayNabc(prNabcData))
    if (pcrDoc?.prAirwayAssess?.length > 0) yield put(setExam(pcrDoc.prAirwayAssess))
    if (pcrDoc?.prAirwayVerificationAssess?.length > 0)
      yield put(setVerificationMethod(pcrDoc.prAirwayVerificationAssess))
  }
}
